<!--
 * @Author: 张天昊
 * @Date: 2024-05-22 15:41:34
 * @LastEditTime: 2024-06-24 15:41:52
 * @LastEditors: 张天昊
 * @Description: 站点服务卡片
 * @FilePath: /Mobile/src/pages/itineraryUniversal/components/ServiceCard.vue
-->
<script>
import { defineComponent, computed } from 'vue';
import CardContainer from './CardContainer.vue';
import Description from './Description.vue';
import WithLink from './WithLink.vue';
import { AuxiliaryInfoTypes } from '../constants';
import { genEmptyTextPlaceholder } from '../utils';
import { navigateToTouristsView } from '../navigate';
import imgGuidePlaceholder from '@/assets/itineraryUniversal/guide-placeholder.png';

export default defineComponent({
  components: {
    CardContainer,
    Description,
    WithLink
  },
  props: {
    data: {
      // {
      //   [AuxiliaryInfoTypes]: {id: string, name: string}[],
      //   tourists: string[],
      //   time: [string, string]
      // }
      type: Object,
      default: () => ({})
    }
  },
  setup(props, { emit }) {
    const computedTime = computed(() => {
      if (!props.data.time) {
        return '';
      }
      return `${props.data.time[0]} 至
      ${props.data.time[1]}
      `;
    });
    const touristsCount = computed(() => props.data.tourists.length);
    function handleClick(type, id) {
      emit('link', { type, id });
    }
    function handleNavigateToTouristsView() {
      navigateToTouristsView(props.data.tourists, '站点参团游客');
    }
    return {
      imgGuidePlaceholder,
      labelWidth: 102,
      AuxiliaryInfoTypes,
      computedTime,
      touristsCount,
      handleClick,
      genEmptyTextPlaceholder,
      handleNavigateToTouristsView
    };
  }
});
</script>

<template>
  <CardContainer>
    <Description :label-width="labelWidth" class="mt-4" label="导游">
      <div
        class="flex-auto"
        v-if="
          data[AuxiliaryInfoTypes.导游] && data[AuxiliaryInfoTypes.导游].length
        "
      >
        <WithLink
          v-for="(item, index) in data[AuxiliaryInfoTypes.导游]"
          :key="item.id"
          :inline="false"
          :class="{ 'mt-14': index > 0 }"
          @click="handleClick(AuxiliaryInfoTypes.导游, item.id)"
        >
          <div class="w-28 h-full flex-shrink-0">
            <van-image
              :error-icon="imgGuidePlaceholder"
              :style="{ position: 'absolute' }"
              :width="$px2rem(28)"
              :height="$px2rem(28)"
              :src="item.photoPath || ''"
              class="-top-4 left-0 custom-avatar"
              fit="cover"
              round
            ></van-image>
          </div>
          <span class="ml-8">{{ item.name }}</span>
        </WithLink>
      </div>
      <span v-else class="text-black-a">{{ genEmptyTextPlaceholder() }}</span>
    </Description>
    <Description :label-width="labelWidth" class="mt-14" label="车辆">
      <div
        v-if="
          data[AuxiliaryInfoTypes.车辆] && data[AuxiliaryInfoTypes.车辆].length
        "
      >
        <WithLink
          v-for="(item, index) in data[AuxiliaryInfoTypes.车辆]"
          :key="item.id"
          :inline="false"
          :class="{ 'mt-6': index > 0 }"
          @click="handleClick(AuxiliaryInfoTypes.车辆, item.id)"
          >{{ item.name }}</WithLink
        >
      </div>
      <span v-else class="text-black-a">{{ genEmptyTextPlaceholder() }}</span>
    </Description>
    <Description :label-width="labelWidth" class="mt-12" label="游客数">
      <WithLink gutter @click="handleNavigateToTouristsView"
        >{{ touristsCount }}人</WithLink
      >
    </Description>
    <Description
      v-if="
        data[AuxiliaryInfoTypes.旅行社] &&
        Array.isArray(data[AuxiliaryInfoTypes.旅行社])
      "
      :label-width="labelWidth"
      class="mt-12"
      label="合作地接社"
    >
      <WithLink
        v-for="(item, index) in data[AuxiliaryInfoTypes.旅行社]"
        :key="item.id"
        :class="{ 'mt-6': index > 0 }"
        :inline="false"
        class="overflow-hidden"
        gutter
        @click="handleClick(AuxiliaryInfoTypes.旅行社, item.id)"
        ><span class="truncate">{{ item.name }}</span></WithLink
      >
    </Description>
    <Description
      v-else-if="
        data[AuxiliaryInfoTypes.旅行社] &&
        'id' in data[AuxiliaryInfoTypes.旅行社]
      "
      :label-width="labelWidth"
      class="mt-12"
      label="带团旅行社"
    >
      <WithLink
        :inline="false"
        gutter
        class="overflow-hidden"
        @click="
          handleClick(
            AuxiliaryInfoTypes.旅行社,
            data[AuxiliaryInfoTypes.旅行社].id
          )
        "
        ><span class="truncate">{{
          data[AuxiliaryInfoTypes.旅行社].name
        }}</span></WithLink
      >
    </Description>
    <Description
      :label-width="labelWidth"
      class="mt-12"
      label="接团日期"
      :content="genEmptyTextPlaceholder(computedTime)"
    />
  </CardContainer>
</template>
